import { useRef } from "react"
import {
  Box,
  Checkbox,
  IconButton,
  MenuItem,
  Select,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  tabsClasses,
} from "@mui/material"
import { DragDropContext, Droppable } from "react-beautiful-dnd"
import { useSelector } from "react-redux"
import { CustomCell } from "./Atom"
import { useDispatch } from "react-redux"
import { setMetricBMTableData } from "../../../../redux/slices/metricSlice"
import DraggableMetric from "./DraggableMetric"
import MetricEditMenu from "../../../Menu/MetricEditMenu"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import EditIcon from "../../../../../assets/icons/edit.svg"
import { getTokenLocal } from "../../../../../helper/utils"
import MetricAPI from "../../../../../api/metric"
import { toast } from "react-toastify"
import { roundUp } from "../../MetricGoalsTable/utils"
import BlueprintAPI from "../../../../../api/blueprint"
import PermsWrapper from "../../../Auth/PermsWrapper"
import { permissions } from "../../../../../config/constants"

const metricAPI = new MetricAPI()
const bluePrintAPI = new BlueprintAPI()
export default function DraggableMetrics(props: any) {
  const dispatch = useDispatch()
  const token = getTokenLocal()

  const tabsRef = useRef<any>(null)

  const {
    currentActiveEditMetricName,
    isChecked,
    handleMetricSelection,
    localMetricNameValue,
    handleGoalTypeValueChange,
    MetricBlueprintDropdownOptions,
    handleEditBenchmarkOpen,
    handleDropdownValueChange,
    index,
    value,
    handleAddTab,
    handleChange,
    handleMetricNameChangeSubmit,
    handleMetricNameChange,
    handleMetricNameEdit,
    setNewBucketName,
    handleEnterToCreateNewBucket,
    setOpen,
    currentActiveEditBucketName,
    localBucketNameValue,
    setCurrentActiveEditMetricName,
    handleMetricNameEditOpen,
    handleMetricDeleteOpen,
    fetchMetricTabs,
  } = props

  let metricBMTableData: any = []

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  const tableData = useSelector((state: any) => {
    return state.metric.metricBMTableData
  })

  const tabs = useSelector((state: any) => {
    return state.metric.tabs
  })

  if (tableData) {
    metricBMTableData = [...tableData]
  } else {
    metricBMTableData = tabs[0]?.metrics
  }

  const onDragEnd = async (result: any) => {
    if (result?.source?.index == result?.destination?.index) {
      return
    }

    const newMetricBMTableData = Array.from(metricBMTableData)
    const draggedRow = newMetricBMTableData.splice(result.source.index, 1)[0]
    newMetricBMTableData.splice(result.destination.index, 0, draggedRow)
    dispatch(setMetricBMTableData([...newMetricBMTableData]))

    const customArr: any = []

    newMetricBMTableData.forEach((metric: any, index: number) => {
      customArr.push({ metric_id: metric?.metric_id, metric_sequence: index })
    })

    if (token) {
      const response = await bluePrintAPI.resequenceMetric(token, customArr)

      if (
        response?.data?.status_code !== 200 &&
        response?.data?.status_code !== 401
      ) {
        toast.error(response?.data?.display_message)
      } else {
        toast.success(response?.data?.display_message)
      }
    }

    await fetchMetricTabs()

    // console.log("source", result.source.index);
  }

  const ChildComps = ({ row, index }: any) => (
    <>
      {
        // rowData?.map((row: any, index: any) => (
        <TableRow key={index} sx={{ padding: 0 }}>
          <CustomCell
            align="left"
            sx={{
              color: "#3C77EF",
              fontSize: "14px",
              fontWeight: "600",
              backgroundColor: "#fff",
              overflow: "hidden",
              // whiteSpace: "nowrap",
              height: "100%",
              minWidth: "217px !important",
              // border: "5px solid red",
              textOverflow: "ellipsis",
              boxShadow: "3px 0 3px -2px #00000029",
              zIndex: "2",
              margin: "0",
            }}
          >
            {currentActiveEditMetricName != index ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "auto 0px",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Checkbox
                    sx={{ padding: "0", outine: "2px solid #B1B0B0" }}
                    checked={isChecked(row?.metric_id)}
                    onChange={(e) =>
                      handleMetricSelection(e, row?.metric_id, row?.metric_name)
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <Tooltip title={row?.metric_hover_text} placement="right">
                    <Typography fontSize={"14px"} sx={{ marginLeft: "10px" }}>
                      {row.metric_name}
                    </Typography>
                  </Tooltip>
                </Box>
                <PermsWrapper perm={permissions?.BLUEPRINT_METRIC_MAINTENANCE}>
                  <MetricEditMenu
                    index={index}
                    value={row.metric_name}
                    handleMetricNameEdit={() =>
                      handleMetricNameEdit({
                        old: row?.metric_name,
                        new: row?.metric_name,
                        id: row?.metric_id,
                      })
                    }
                    handleMetricDeleteOpen={handleMetricDeleteOpen}
                    metricId={row.metric_id}
                  />
                </PermsWrapper>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "auto 0px",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  id="standard-basic"
                  onChange={(e) => handleMetricNameChange(e.target.value)}
                  value={localMetricNameValue}
                  autoFocus
                  onBlur={() => setCurrentActiveEditMetricName(-1)}
                  variant="standard"
                  sx={{ margin: "0px", padding: "0" }}
                />
                <CheckCircleIcon
                  // onClick={() => handleMetricNameChangeSubmit(
                  //     row?.metric_id,
                  // )}
                  onClick={() =>
                    handleMetricNameEditOpen(
                      row?.metric_name,
                      localMetricNameValue,
                      row?.metric_id,
                    )
                  }
                  sx={{ cursor: "pointer" }}
                  color="success"
                />
              </Box>
            )}
          </CustomCell>
          <CustomCell
            align="center"
            sx={{
              backgroundColor: row?.goal_type ? "#FFFFFF" : "#F7F7F7",
              zIndex: "1",
              color: "#3C77EF",
              fontSize: "14px",
              fontWeight: "600",
              overflow: "hidden",
              // whiteSpace: "nowrap",
              minWidth: "217px !important",
              height: "100%",
              // width: "fit-content",
              textOverflow: "ellipsis",

              borderRight: "1px solid #E4E4E4",

              margin: "0",
            }}
          >
            <Select
              sx={{
                width: "100%",
                padding: "0px",
                border: "none",
                fontSize: "14px",
                fontWeight: "bold",
                "& .MuiOutlinedInput-notchedOutline": {
                  outline: "none",
                  border: "none",
                },

                color: "#000",
                textAlign: "left",
                paddingLeft: "10px",
              }}
              disabled={
                !allPerms.includes(permissions?.BLUEPRINT_UPDATE_DATATYPE)
              }
              IconComponent={KeyboardArrowDownIcon}
              value={
                row?.goal_type == ""
                  ? "N/A"
                  : !row?.goal_type
                  ? "N/A"
                  : row?.goal_type
              }
              onChange={(e) => {
                handleGoalTypeValueChange(row?.metric_id, e.target.value)
              }}
            >
              {MetricBlueprintDropdownOptions.map((option: any) => {
                return (
                  <MenuItem
                    key={option}
                    sx={{
                      margin: "0px 10px 0px 10px",
                      color: "#000",
                      "& .MuiButtonBase-root": {
                        outline: "none",
                        border: "none",
                        backgroundColor: "white",
                        color: "#000",
                      },
                    }}
                    value={option}
                  >
                    {option}
                  </MenuItem>
                )
              })}
            </Select>
          </CustomCell>
          <CustomCell
            align="left"
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              // backgroundColor: "#fff",
              backgroundColor: row?.goal_type == "" ? "#F7F7F7" : "#FFFFFF",
              overflow: "hidden",
              // whiteSpace: "nowrap",
              minWidth: "217px !important",
              height: "100%",
              width: "fit-content",
              textOverflow: "ellipsis",
              borderRight: "1px solid #E4E4E4",
              zIndex: "0",
              margin: "0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "auto 0px",
                justifyContent: "space-between",
              }}
            >
              <Typography
                fontSize={"14px"}
                sx={{
                  marginLeft: "10px",
                  color: row?.goal_type == "" ? "#909090" : "#000000",
                }}
              >
                {/* {currentActiveEditBenchmark == index ? row.metric_benchmark : localBenchmarkValue} */}
                {row?.goal_type == ""
                  ? 0
                  : roundUp(
                      row?.metric_benchmark,
                      row?.goal_type,
                      row?.metric_precision,
                    )}
              </Typography>
              <PermsWrapper perm={permissions?.BLUEPRINT_UPDATE_BENCHMARK}>
                <img
                  src={EditIcon}
                  height={"12px"}
                  alt=""
                  style={{
                    cursor: row?.goal_type == "" ? "not-allowed" : "pointer",
                  }}
                  onClick={() => {
                    row?.goal_type == ""
                      ? null
                      : handleEditBenchmarkOpen(
                          row?.metric_id,
                          row?.metric_benchmark,
                          row?.goal_type,
                        )
                  }}
                />
              </PermsWrapper>
            </Box>
          </CustomCell>
          {metricBMTableData[index]?.columns?.map((column: any, i: any) => {
            return (
              <TableCell
                key={i}
                align="center"
                sx={{
                  minWidth: "200px !important",
                  borderRight: "1px solid #E4E4E4",
                  backgroundColor: column?.column_datatype
                    ? "#FFFFFF"
                    : "#F7F7F7",
                }}
              >
                <Select
                  sx={{
                    width: "100%",
                    padding: "0px",
                    border: "none",
                    fontSize: "14px",
                    fontWeight: "bold",
                    "& .MuiOutlinedInput-notchedOutline": {
                      outline: "none",
                      border: "none",
                    },

                    color: "#000",
                    textAlign: "left",
                    paddingLeft: "10px",
                  }}
                  disabled={
                    !allPerms.includes(permissions?.BLUEPRINT_UPDATE_DATATYPE)
                  }
                  IconComponent={KeyboardArrowDownIcon}
                  value={column?.column_datatype || "N/A"}
                  onChange={(e) => {
                    handleDropdownValueChange(
                      row?.metric_id,
                      column?.column_id,
                      e.target.value,
                    )
                  }}
                >
                  {MetricBlueprintDropdownOptions.map((option: any) => {
                    return (
                      <MenuItem
                        key={option}
                        sx={{
                          margin: "0px 10px 0px 10px",
                          color: "#000",
                          "& .MuiButtonBase-root": {
                            outline: "none",
                            border: "none",
                            backgroundColor: "white",
                            color: "#000",
                          },
                        }}
                        value={option}
                      >
                        {option}
                      </MenuItem>
                    )
                  })}
                </Select>
              </TableCell>
            )
          })}
        </TableRow>
        // ))
      }
    </>
  )

  const _renderRowList = (droppableProvided: any) => (
    <>
      {metricBMTableData?.map((row: any, idx: any) => (
        <DraggableMetric
          index={idx}
          key={idx}
          child={ChildComps({ row: row, index: idx })}
        />
      ))}
    </>
  )

  const _renderRowListWrappedInDroppable = () => (
    <DragDropContext onDragEnd={onDragEnd}>
      {/* <Box sx={{ display: "flex", overflow: "auto" }} className="styled-scrollbar"> */}
      <Droppable droppableId="1" direction="vertical">
        {(droppableProvided: any) => (
          <TableBody
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
            {...droppableProvided.dropHandleProps}
          >
            {_renderRowList(droppableProvided)}
          </TableBody>
        )}
      </Droppable>
      {/* </Box> */}
    </DragDropContext>
  )

  return _renderRowListWrappedInDroppable()
}
